module.exports = __webpack_public_path__ + "static/media/04C.ad4eadb3.png";